// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div class="password-reset">
    <v-dialog persistent v-model="visible" absolute max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Reset Password</div>
        </v-card-title>
        <v-card-text>
          <v-text-field
            name="input"
            label="Password"
            v-model="passwordReset1"
            required
            type="password"
            counter
            :min="passwordLength"
            :rules="[passwordStrength]">
          ></v-text-field>
          <v-text-field
            name="input"
            label="Password"
            v-model="passwordReset2"
            required
            type="password"
            counter
            :rules="[passwordsEqual]">
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="setVisible(false)">Cancel</v-btn>
          <v-btn text color="red" @click.native="resetPassword">Reset Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </div>
</template>

<script>
  import {AXIOSAPI} from './requests-common'
  import ErrorSnackbar from './ErrorSnackbar'
  import Rules from './rules'
  import zxcvbn from 'zxcvbn'

  export default {
    name: 'password-reset',

    components: {
      ErrorSnackbar
    },

    data () {
      return {
        errorText: '',
        isActive: this.value,
        passwordLength: Rules.PASSWORDLENGTH,
        passwordReset1: '',
        passwordReset2: '',
        visible: false
      }
    },

    props: {
      value: Boolean,
      user: Object,
      endpoint: String
    },

    watch: {
      value (val) {
        if (val !== this.visible) {
          this.visible = val
        }
      }
    },

    computed: {
      passwordsEqual: function () {
        if (this.passwordReset1 === this.passwordReset2) {
          return true
        } else {
          return 'Passwords are not the same'
        }
      },

      passwordStrength: function() {
        let strength = zxcvbn(this.passwordReset1, [this.user.name, this.user.username])
        if(strength.score < Rules.PASSWORDSTRENGTH) {
          return 'Password too weak'
        } else {
          return true
        }
      },
    },

    methods: {
      setVisible (value) {
        this.visible = value
        this.$emit('input', this.visible)
      },

      resetPassword: function () {
        if (this.passwordsEqual && (Rules.password(this.passwordReset1) === true)) {
          this.$props.user.password = this.passwordReset1
          AXIOSAPI.put(this.$props.endpoint + 'users/' + this.$props.user.id, this.user).then(response => {
            this.passwordReset1 = ''
            this.passwordReset2 = ''
            this.visible = false
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        } else {
          this.errorText = 'Please enter a valid password'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PasswordReset.vue?02152e5a